import { Command } from '@/app/common/base/command'

export class SubmitHypactProfileCommand extends Command {
    public async run(data: {}, productActionId: string) {
        await this.client.post('/api/advice_profile', { data, productActionId })
    }
}
